import Routes from "security-app/routing/Routes";
export const PAGE_NAV_TITLE = "Sigma Rules";
const sigmaPageNavigation = {
  description: PAGE_NAV_TITLE,
  children: [
    { description: "Rules", path: Routes.SIGMA.LIST, exactPathMatch: true },
    { description: "Sigma Repos", path: Routes.SIGMA.CONFIGURATION, permissions: ["sigma_repository:read"] }
  ]
};
export default sigmaPageNavigation;
